<template>
<ul :style="{'line-height': lineHeight}" class="layout-header-nav">
  <li
    v-for="nav in navList"
    :key="nav.name"
    ref="navItem"
    :class="{active: !!matchedMap[nav.path]}"
    class="layout-header-nav-item"
    @click="onNavItemClick(nav)"
  >{{nav.label}}</li>
</ul>
</template>

<script>
import BaseStore from '../BaseStore'

export default {
  name: 'LayoutMainNav',
  extends: BaseStore,
  props: {
    lineHeight: {
      type: String
    }
  },
  computed: {
    matchedMap () {
      return this.$route.matched.reduce((map, {path}) => {
        map[path] = true
        return map
      }, {})
    }
  },
  methods: {
    onNavItemClick (nav) {
      while (Array.isArray(nav.children)) {
        nav = nav.children[0]
      }

      let routeName = nav.name

      if (this.$route.name === routeName) {
        return
      }

      this.$router.push({
        name: routeName
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-header-nav {
  position: relative;
  margin: 0;
  padding: 0;
  height: 100%;

  > .layout-header-nav-item {
    $OPERATOR-COLOR: #E6A23C;
    color: #ffffff;

    float: left;
    padding: 0 20px;
    transition: border-color .3s, background-color .3s, color .3s;
    cursor: pointer;

    &:hover {
      color: $OPERATOR-COLOR;
      background-color: rgba(0, 0, 0, 0.1);
    }

    &.active {
      color: #ffffff;
      background-color: $OPERATOR-COLOR;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/MainNav.vue